import { errors, network } from "@/locales/languages/es_MX";
import * as R from "ramda";
import {EventBus} from '@/events/event-bus';
import * as events from '@/constants/event-names';

const getCodeDescription = R.curry((source, catalogo, defaultMessage='', code) => {
  return (((source || {})[catalogo] || {})[code] || {}).text || defaultMessage;
});


export const getBusinessCode = function(response){
  let businessCode = "ERROR";
  if(response && response.status==200)
  {
    if(((response.data || {}).meta || {}).code == "OK" )
    {
      businessCode = response.data.meta.code;
    } 
    else if(((response.data || {}).meta || {}).code || 'ERROR')
    {
      businessCode = response.data.meta.code;
    }
  }
  return businessCode;
};

export const getResponseDTO = function(response){
  let responseDTO = null;
  if(response && response.status==200)
  {
    if((response.data || {}).results)
    {
      responseDTO = response.data.results != undefined ? response.data.results : null;
    }
  }
  return responseDTO;
};

export const handleResponseMessage= function({response, modulo}){
  const code = getBusinessCode(response);
  const messageError = 'Error al hacer la petición';
  if(code == 'OK')
  {
    EventBus.$emit(events.MESSAGES, {type:code});
    return true;
  }
  else 
  {
    if(response != false)
      EventBus.$emit(events.MESSAGES, {type:'error',message: getErrors(modulo,messageError,code)});
    throw messageError
  }
}

export const getErrors = getCodeDescription(errors);
export const getErrorsNetwork = getCodeDescription(network);



// WEBPACK FOOTER //
// ./src/helpers/http-response-handler.js